import { COLORS } from "../lib/colors";

export default function SearchTermsChart({ terms }) {
  if (!terms || terms.length === 0) {
    return (
      <div>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: COLORS.text, marginBottom: 12 }}>
          What Recruiters Search For
        </h3>
        <p style={{ fontSize: 13, color: COLORS.textMuted }}>No searches yet.</p>
      </div>
    );
  }

  const maxCount = terms[0].count || 1;

  return (
    <div>
      <h3 style={{ fontSize: 16, fontWeight: 700, color: COLORS.text, marginBottom: 12 }}>
        What Recruiters Search For
      </h3>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {terms.map((t, i) => (
          <div key={i}>
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 13,
              color: COLORS.textSecondary,
              marginBottom: 4,
            }}>
              <span>{t.term}</span>
              <span>{t.count}</span>
            </div>
            <div style={{
              height: 6,
              borderRadius: 3,
              backgroundColor: COLORS.surfaceAlt,
              overflow: "hidden",
            }}>
              <div style={{
                height: "100%",
                width: `${(t.count / maxCount) * 100}%`,
                backgroundColor: COLORS.accent,
                borderRadius: 3,
              }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
